<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu" />
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.stripeCharge.menu" />
      </el-breadcrumb-item>
    </el-breadcrumb>
    <slot name="title"/>
    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.stripeCharge.list.title" />
      </h1>

      <app-stripe-charge-list-toolbar />
      <app-stripe-charge-list-filter 
          :inscriptionId="inscriptionId"
      />
      <app-stripe-charge-list-table />
    </div>
  </div>
</template>

<script>
import StripechargeListFilter from '@modules/stripe/stripe-charge/components/stripe-charge-list-filter.vue';
import StripechargeListTable from '@modules/stripe/stripe-charge/components/stripe-charge-list-table.vue';
import StripechargeListToolbar from '@modules/stripe/stripe-charge/components/stripe-charge-list-toolbar.vue';

export default {
  name: 'app-stripe-charge-list-page',
  props: {
    inscriptionId: {
      type: String,
      default: null,
    },
  },
  components: {
    [StripechargeListFilter.name]: StripechargeListFilter,
    [StripechargeListTable.name]: StripechargeListTable,
    [StripechargeListToolbar.name]: StripechargeListToolbar,
  },
};
</script>

<style>
</style>
